import axios from 'axios';
// REACT_APP_YOUTUBE_API_KEY
// const GOOGLE_API_KEY = 'AIzaSyDUXy_0yIAYRO5SDaZcWiZnJMgQryXPi6E'; // firebase generated
// const GOOGLE_API_KEY = 'AIzaSyDfyTJeqiUUUXQi0wwTPMkgos9cDzxAqRI'; // only youtube api key
const GOOGLE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY; // only youtube api key

const CHANNEL_ID = 'UC181EuuUou8HFuDRMi-G3Ww';
const DEFAULT_PLAYLIST_ID = 'PLOEf1h2CrvDtP9eudfchzya9V1hG_MmFb';

const MAX_PAGE_LIMIT = 50;
const YOUTUBE_BASE_URL = 'https://www.googleapis.com/youtube/v3';

const googleApiRequest = axios.create({
	baseURL: YOUTUBE_BASE_URL,
	params: {
		key: GOOGLE_API_KEY
	}
});

export const fetchChannelPlaylists = async () => {
	const result = await googleApiRequest('/playlists', {
		params: {
			part: 'snippet,contentDetails',
			channelId: CHANNEL_ID,
			maxResults: MAX_PAGE_LIMIT,
			fields: 'items(id,snippet.title,snippet/description,contentDetails/itemCount)'
		}
	});

	const playlists = result.data.items.map(playlist => ({
		id: playlist.id,
		...playlist.snippet,
		...playlist.contentDetails
	}));
	return playlists;
};

export const fetchPlaylistItems = async playlist => {
	const result = await googleApiRequest('/playlistItems', {
		params: {
			part: 'snippet,contentDetails,status',
			maxResults: MAX_PAGE_LIMIT,
			playlistId: playlist.id,
			fields: 'items(id,snippet/title,snippet/description,snippet/playlistId,snippet/publishedAt,snippet/thumbnails,contentDetails/videoId,contentDetails/videoPublishedAt,status/privacyStatus)'
		}
	});

	const publicVideos = result.data.items.filter(item =>
		['public', 'unlisted'].includes(item.status.privacyStatus.toLowerCase())
	);
	const appPlaylistVideos = publicVideos.map(video => {
		const {
			id,
			snippet: { title, description, playlistId, publishedAt, thumbnails },
			contentDetails: { videoId, videoPublishedAt: videoUploadedAt },
			status: { privacyStatus }
		} = video;
		return {
			id,
			videoId,
			title,
			description,
			playlistId,
			publishedAt,
			videoUploadedAt,
			thumbnails,
			privacyStatus
		};
	});

	return {
		...playlist,
		videos: appPlaylistVideos
	};
};

export const fetchPlaylistAllVideoDetails = async (videoIds = []) => {
	const details = await googleApiRequest(`/videos`, {
		params: {
			part: 'snippet,statistics',
			id: videoIds.join(','),
			fields: `items(id,snippet/tags,statistics/viewCount)`
		}
	});

	return details.data.items;
};

export const fetchChannelPlaylistsWithVideos = async () => {
	//fetch channel playlists
	const channelPlaylists = await fetchChannelPlaylists();

	//fetch playlist videos
	const allPlaylistVideos = await Promise.all(channelPlaylists.map(fetchPlaylistItems));

	//fetch all video details
	const allVideoIds = allPlaylistVideos.reduce((acc, curr) => acc.concat(curr.videos.map(v => v.videoId)), []);
	const allVideoDetails = await fetchPlaylistAllVideoDetails(allVideoIds);

	// map all playlists to videos with video details
	return allPlaylistVideos.map(playlist => {
		const videos = playlist.videos.map(video => {
			const {
				snippet: { tags },
				statistics: { viewCount }
			} = allVideoDetails.find(vd => vd.id === video.videoId);

			return {
				...video,
				tags,
				viewCount: +viewCount
			};
		});

		return {
			...playlist,
			videos
		};
	});
};
